define('viewModels/privileged/qm/EvaluationSummaryView',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'moment',
    'services/qualityManagementService',
    'services/notificationService',
    'services/userService',
    'services/loggingService',
    'services/toastService',
    'services/qm/qualityAuth',
    'services/navHelper',
    'viewModels/ViewModel',
    'util/errorCallbackFactory'
], function (
    ko,
    _,
    Promise,
    moment,
    qualityManagementService,
    notificationService,
    userService,
    loggingService,
    toastService,
    qualityAuthorization,
    navHelper,
    ViewModel,
    errorCallbackFactory
) {
    'use strict';

    var EVALUATION_SUMMARY_COLUMNS = [
        {
            label: 'evaluationSummary.formNameTitle',
            id: 'formName'
        },
        {
            label: 'evaluationSummary.dateTitle',
            id: 'assignedDate'
        },
        {
            label: 'evaluationSummary.evaluatorTitle',
            id: 'evaluator'
        },
        {
            label: 'evaluationSummary.statusTitle',
            id: 'status'
        },
        {
            label: 'evaluationSummary.timeRemainingToDeleteTitle',
            id: 'timeRemainingToDelete'
        },
        {
            label: 'evaluationSummary.agentHasReadTitle',
            id: 'agentHasRead'
        }];

    var oneMinuteMs = 60 * 1000;
    var oneHourMs = 60 * 60 * 1000;
    var oneDayMs = 24 * 60 * 60 * 1000;

    var EvaluationSummaryView = ViewModel.extend(function (conversationId, hasParticipantToEvaluate, deleteEvaluationCallback) {
        var self = this;
        var evaluationStatus;
        self.hasParticipantToEvaluate = hasParticipantToEvaluate;
        self.evaluationSummaryGrid = ko.observableArray();
        self.newEvaluationHref = '#admin/interactions/' + conversationId() + '/evaluations/new';
        self.canAddEvaluation = ko.observable(qualityAuthorization.canAddEvaluation());
        self.canDeleteEvaluation = ko.observable(qualityAuthorization.canDeleteEvaluation());
        var notificationTopic = [];
        var topic = "v2.conversations."+conversationId()+".evaluations";

        /**
         *  If the EventType of the evaluation is Deleted the we will remove just that evaluation from the list
         *  If the EventType is Submitted, just update the existing rows information
         *  If none of the conditions above are met, then the evaluation being passed to the function should be a newly
         *      assigned evaluation. In this case we will reload the grid to get the new entry.
         */
        var handleEvaluationUpdate = function(evaluationNotification) {
            var updatedRows = [];

            if(evaluationNotification.eventType === "DELETED") {
                /**
                 * Deleted selected rows and update collection
                 */
                updatedRows = _.reject(self.evaluationSummaryGrid().rows(), {'evaluationId': evaluationNotification.id});
                self.evaluationSummaryGrid().rows(updatedRows);
            }
            if(evaluationNotification.eventType === "ASSIGNED") {
                var conversationId = evaluationNotification.conversationId;
                var evaluationStatus = getStatusString(evaluationNotification.status.toLowerCase());
                var evaluationAssignedDate = {
                    date: moment(evaluationNotification.assignedDate).toDate(),
                    href: "#admin/interactions/" + conversationId + "/evaluations/" + evaluationNotification.id
                };
                var evaluationCreatedDate = evaluationNotification.createdDate;
                var formName = evaluationNotification.formName;
                var displayName = ko.i18n.renderString('evaluationSummary.displayName.none');
                // Request the user to get the name if we don't already have it
                var displayNamePromise = evaluationNotification.evaluator.displayName ?
                    Promise.resolve(evaluationNotification.evaluator) :
                    userService.getUser(evaluationNotification.evaluator.id);
                displayNamePromise.then(function (user) {
                    displayName = ko.unwrap(user.name || user.displayName);
                }).finally(function () {
                    var newRow = buildRow(evaluationNotification,
                        conversationId,
                        formName,
                        evaluationStatus,
                        evaluationAssignedDate,
                        evaluationCreatedDate,
                        displayName);
                    if (newRow) {
                        var currentRows = self.evaluationSummaryGrid().rows();
                        currentRows.unshift(newRow);
                        self.evaluationSummaryGrid().rows(currentRows);
                    }
                });
            }
            if(evaluationNotification.eventType === "SUBMITTED" || evaluationNotification.eventType === "RELEASED") {
                /**
                 * Update the row based on submitted evaluations
                 */
                var updatedRowIndex = _.findIndex(self.evaluationSummaryGrid().rows(), {'evaluationId': evaluationNotification.id});
                var rowToUpdate = self.evaluationSummaryGrid().rows()[updatedRowIndex];
                rowToUpdate.status = getStatusString(evaluationNotification.status);
                rowToUpdate.agentHasRead = evaluationNotification.agentHasRead ? 'evaluationSummary.agentHasRead.yes' : 'evaluationSummary.agentHasRead.no';
                updatedRows = _.pull(self.evaluationSummaryGrid().rows(), self.evaluationSummaryGrid().rows()[updatedRowIndex]);
                updatedRows.splice(updatedRowIndex, 0, rowToUpdate);
                self.evaluationSummaryGrid().rows(updatedRows);
            }
            self.updateTimesRemainingToDelete();
        };

        var getStatusString = function(status){
            var evaluationStatus;
            if(status === "pending") {
                evaluationStatus = "evaluationSummary.pending";
            } else if (status === "inprogress") {
                evaluationStatus = "evaluationSummary.inProgress";
            } else {
                evaluationStatus = "evaluationSummary.finished";
            }
            return evaluationStatus;
        };

        var buildRow = function(
            evaluation,
            conversationId,
            formName,
            evaluationStatus,
            evaluationAssignedDate,
            evaluationCreatedDate,
            displayName
        ){
            var timeRemainingToDeleteMs = ko.observable();
            return {
                'conversationId': conversationId,
                'evaluationId': evaluation.id,
                'formName': formName,
                'assignedDate': evaluationAssignedDate,
                'createdDate': evaluationCreatedDate,
                'timeRemainingToDeleteMs': timeRemainingToDeleteMs,
                'isEvaluationTooOldToDelete': ko.computed(function(){
                    return timeRemainingToDeleteMs() <= 0;
                }),
                'timeRemainingToDelete': ko.observable(),
                'evaluator': displayName,
                'status': evaluationStatus,
                'agentHasRead': evaluation.agentHasRead ? 'evaluationSummary.agentHasRead.yes' : 'evaluationSummary.agentHasRead.no'
            };
        };

        self.listEntities = function(evaluations) {
            var conversationId,
                evaluationAssignedDate,
                displayName,
                formName;

            var rows = _.map(evaluations, function(evaluation){

                conversationId = evaluation.conversation.id;
                evaluationStatus = getStatusString(evaluation.status.toLowerCase());
                evaluationAssignedDate = {
                    date: moment(evaluation.assignedDate).toDate(),
                    href: "#admin/interactions/" + conversationId + "/evaluations/" + evaluation.id
                };
                displayName = evaluation.evaluator.name;
                formName = evaluation.evaluationForm.name;

                return buildRow(evaluation, conversationId, formName, evaluationStatus, evaluationAssignedDate, evaluation.createdDate, displayName);
            });
            self.evaluationSummaryGrid().rows(rows);
            self.updateTimesRemainingToDelete();
        };

        self.createNewEvaluation = function () {
            navHelper.navigateTo(self.newEvaluationHref);
        };

        self.deleteSelectedRows = function () {
            var selectedRows = self.evaluationSummaryGrid().selectedRows();
            deletedRows = [].concat(selectedRows);
            var deletedRows = [];
            // selectedRows will return a single object when one row is selected
            // it will return an array when multiple rows are selected.
            _.each(selectedRows, function(row) {
                deletedRows.push(deleteEvaluationCallback(row.conversationId, row.evaluationId));
            });

            Promise.settle(deletedRows)
                .then(function(promiseResults){
                    var failedResults = 0;
                    //Check for a single error on row delete
                    _.each(promiseResults, function(deletedRowPromise){
                        if(deletedRowPromise.isRejected()){
                            failedResults++;
                            loggingService.error("Failed to delete evaluation", deletedRowPromise._settledValue);
                        }
                    });

                    if(failedResults !== promiseResults.length && failedResults !== 0) {
                        toastService.notifyCriticalAlert(
                            'evaluationSummary.error.delete',
                            {
                                bodyMessage: 'evaluationSummary.error.delete.body',
                                messageData: failedResults
                            }
                        );
                    } else if (failedResults === promiseResults.length) {
                        toastService.notifyCriticalAlert('evaluationSummary.error.delete.all');
                    }
                });
        };

        function refreshEvaluationSummaryGrid(incomingOptions) {
            return qualityManagementService.getConversationEvaluations(conversationId(), incomingOptions)
                .then(function (response) {
                    var newOptions = _.assign({}, _.pick(response, ['pageNumber', 'pageCount']), incomingOptions);
                    self.gridOptions(newOptions);
                    self.listEntities(response.entities);
                })
                .catch(errorCallbackFactory.createCallback({
                    namespace: "playback.evaluationSummaryRequest"
                }))
                .finally(function () {
                    self.evaluationSummaryGrid().loading(false);
                });
        }

        self.gridOptions = ko.observable({
            pageNumber: 1
        });

        // Add the appropriate information to the dataTable
        self.evaluationSummaryGrid({
            columns: EVALUATION_SUMMARY_COLUMNS,
            rows: ko.observableArray([]),
            selectedRows: ko.observableArray([]),
            loading: ko.observable(true),
            onDataOptionsChange: refreshEvaluationSummaryGrid,
            dataOptions: self.gridOptions
        });

        // Look for row selection to handle evaluation deletion
        self.canDeleteRows = self.computed(function() {
            return qualityAuthorization.canDeleteEvaluation() && !_.isEmpty(self.evaluationSummaryGrid().selectedRows());
        });

        // When a row is selected but the evaluation can't be deleted, deselect that row
        self.uncheckUndeletableRows = function(rows){
            var deletableRows = [];
            var hasRowsToUncheck = false;
            _.each(rows, function(row){
                if(row.timeRemainingToDeleteMs && row.timeRemainingToDeleteMs() <= 0){
                    hasRowsToUncheck = true;
                } else {
                    deletableRows.push(row);
                }
            });
            if(hasRowsToUncheck){
                self.evaluationSummaryGrid().selectedRows(deletableRows);
            }
        };

        self.evaluationSummaryGrid().selectedRows.subscribe(self.uncheckUndeletableRows);

        function getFormattedTimeRemainingToDelete(timeRemainingToDeleteMs){
            if(timeRemainingToDeleteMs() > oneDayMs){
                return ko.i18n.renderString({
                    'name': 'evaluationSummary.timeRemainingToDelete.days',
                    'data': {
                        "daysRemaining": Math.floor(timeRemainingToDeleteMs() / oneDayMs),
                        "hoursRemaining": Math.floor((timeRemainingToDeleteMs() % oneDayMs) / oneHourMs)
                    }
                });
            } else if(timeRemainingToDeleteMs() > 0) {
                // be more granular when less than a day left
                return ko.i18n.renderString({
                    'name': 'evaluationSummary.timeRemainingToDelete.hours',
                    'data': {
                        "hoursRemaining": Math.floor(timeRemainingToDeleteMs() / oneHourMs),
                        "minutesRemaining": Math.floor((timeRemainingToDeleteMs() % oneHourMs) / oneMinuteMs)
                    }
                });
            } else {
                return ko.i18n.renderString('evaluationSummary.timeRemainingToDelete.outOfTime');
            }
        }

        self.updateTimesRemainingToDelete = function(){
            if(!self.evaluationSummaryGrid || !self.evaluationSummaryGrid()){
                return;
            }
            _.each(self.evaluationSummaryGrid().rows(), function(row){
                if(!row.createdDate && !row.assignedDate){
                    return;
                }
                row.timeRemainingToDeleteMs(moment(row.createdDate || row.assignedDate.date).add(90, 'days').diff(moment()));
                row.timeRemainingToDelete(getFormattedTimeRemainingToDelete(row.timeRemainingToDeleteMs));
            });
        };

        // Update each minute the amount of time left to delete each evaluation
        var updateTimesRemainingToDeleteTimer;
        (function regularlyUpdateTimesRemaining(){
            self.updateTimesRemainingToDelete();
            self.uncheckUndeletableRows();
            updateTimesRemainingToDeleteTimer = setTimeout(regularlyUpdateTimesRemaining, oneMinuteMs);
        })();

        // Subscribe to the notifications
        if(notificationTopic[topic]) {
            loggingService.warn('Failed to subscribe to topic ', { topic: topic });
        } else {
            notificationTopic[topic] = handleEvaluationUpdate;
        }

        notificationService.subscribe(topic, handleEvaluationUpdate)
            .finally(function() {
                refreshEvaluationSummaryGrid(self.gridOptions());
            });

        self.onDispose = function () {
            clearTimeout(updateTimesRemainingToDeleteTimer);
            notificationService.batchUnsubscribe(topic);
        };
    });

    return EvaluationSummaryView;
});

